import PropTypes from 'prop-types'

import {
  SectionTitle,
  CodeWrapper,
  CodeBlock
} from 'components/common/Codeblock'
import { CopyButton } from 'components/common/CopyButton'
import theme from 'theme'

const RedHatEL = ({ colorTheme, ...rest }) => (
  <CodeWrapper {...rest}>
    <div css={{ paddingBottom: theme.space[2] }}>
      <div css={{ display: 'flex', alignItems: 'flex-end' }}>
        <SectionTitle colorTheme={colorTheme}>
          Install iproute-tc, a dependency for Gremlin:
        </SectionTitle>
        <CopyButton
          colorTheme={colorTheme}
          content="sudo yum install -y iproute-tc"
        />
      </div>
      <CodeBlock code="sudo yum install -y iproute-tc" language="bash" />
    </div>

    <div css={{ paddingBottom: theme.space[2] }}>
      <div css={{ display: 'flex', alignItems: 'flex-end' }}>
        <SectionTitle colorTheme={colorTheme}>
          Add the Gremlin repo:
        </SectionTitle>
        <CopyButton
          colorTheme={colorTheme}
          content="sudo curl https://rpm.gremlin.com/gremlin.repo -o /etc/yum.repos.d/gremlin.repo"
        />
      </div>
      <CodeBlock code="sudo curl https://rpm.gremlin.com/gremlin.repo -o /etc/yum.repos.d/gremlin.repo" />
    </div>

    <div css={{ paddingBottom: theme.space[2] }}>
      <div css={{ display: 'flex', alignItems: 'flex-end' }}>
        <SectionTitle colorTheme={colorTheme}>
          Then install the Gremlin client and daemon:
        </SectionTitle>
        <CopyButton
          colorTheme={colorTheme}
          content="sudo yum install -y gremlin gremlind"
        />
      </div>
      <CodeBlock code="sudo yum install -y gremlin gremlind" />
    </div>

    <div css={{ paddingBottom: theme.space[2] }}>
      <div css={{ display: 'flex', alignItems: 'flex-end' }}>
        <SectionTitle colorTheme={colorTheme}>
          Obtain your Gremlin Team ID and Secret Key, then finish configuring
          the client:
        </SectionTitle>
        <CopyButton colorTheme={colorTheme} content="gremlin init" />
      </div>
      <CodeBlock code="gremlin init" />
      <SectionTitle colorTheme={colorTheme}>
        Input your Team ID and Secret Key when you&apos;re prompted for them.
      </SectionTitle>
    </div>
  </CodeWrapper>
)

RedHatEL.propTypes = {
  colorTheme: PropTypes.oneOf(['light', 'dark'])
}

export default RedHatEL
